/* eslint-disable no-underscore-dangle */
import type { ObjectDirective, } from 'vue';

interface ClickOutsideElement extends HTMLElement {
  sid: string;
  _handleClickOutside: (event: Event) => void;
}

const EVENTS = ['click', 'touchstart', 'mousedown', 'pointerdown',];

export const vClickOutside: ObjectDirective<
  ClickOutsideElement,
  (e: Event) => void
> = {
  mounted(el, binding) {
    let isProcessingClick = false;

    el._handleClickOutside = (event) => {
      // 检查点击事件是否发生在元素外部
      if (!(el === event.target || el.contains(event.target as Node))) {
        if (binding.modifiers.stop) {
          event.stopPropagation();
          event.stopImmediatePropagation();
        }

        // 避免重复触发
        if (isProcessingClick) {
          return;
        }
        isProcessingClick = true;
        setTimeout(() => {
          isProcessingClick = false;
        }, 100);
        binding.value(event);
      }
    };
    // 绑定事件监听器到 document
    EVENTS.forEach((eventName) => {
      document.addEventListener(eventName, el._handleClickOutside, true);
    });
  },
  unmounted(el) {
    // 延迟移除事件监听器以避免 click 事件被触发
    setTimeout(() => {
      EVENTS.forEach((eventName) => {
        document.removeEventListener(eventName, el._handleClickOutside, true);
      });
    }, 500);
  },
};

export const vClickOutsideName = 'clickOutside';
